import { Stack } from 'components/Stack';
import styled from 'styled-components';

export const Container = styled(Stack).attrs({
  direction: 'column',
  justify: 'center',
  align: 'center',
  gap: 8,
})`
  height: 100%;
  text-align: center;
`;

export const Title = styled.span`
  font-weight: 600;
  font-size: 20px;
  line-height: 24px;
`;

export const Text = styled.span`
  font-size: 16px;
  line-height: 24px;
  margin-bottom: 16px;
`;
